module.exports = __webpack_public_path__ + "static/media/flamingo.99c0097b.png";